$(document).ready(function () {
  $(".carousel-with-text__carousel").slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: false,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
  });

  if (window.innerWidth > 700) {
    $(".collection-products__item__carousel").hover((ev) => {
      if (!$(ev.currentTarget).hasClass("slick-initialized")) {
        $(ev.currentTarget).slick({
          slidesToScroll: 1,
          slidesToShow: 1,
          arrows: true,
          // dots: true,
          infinite: true,
          // autoplaySpeed: 3000,
        });
      }
    });
  } else {
    //  $(".collection-products__item__carousel").hover((ev) => {
    //  if (!$(ev.currentTarget).hasClass("slick-initialized")) {
    $(".collection-products__item__carousel").slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      arrows: true,
      lazyLoad: "ondemand",
      // dots: true,
      infinite: true,
      // autoplaySpeed: 3000,
    });
    //  }
    //  });/
  }

  $(".product-media-modal__content .slick-wrapper").slick({
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: true,
    // dots: true,
    infinite: true,
    // autoplaySpeed: 3000,
  });

  $(".product__media-toggle").click((ev) => {
    setTimeout(() => {
      $(".product-media-modal__content .slick-wrapper")[0].slick.slickGoTo(
        $(ev.currentTarget).data("loop-id") - 1,
        false
      );
    }, 300);
  });

  // $(".product-media-modal__content").slick({
  //   // slidesToScroll: 1,
  //   // slidesToShow: 1,
  //   // arrows: false,
  //   // dots: true,
  //   // infinite: true,
  //   // autoplay: true,
  //   // autoplaySpeed: 3000,
  // });

  // $(".hero__link").click(function (e) {
  //   e.preventDefault();
  //   let target = $(this).attr("href");
  //   $([document.documentElement, document.body]).animate(
  //     {
  //       scrollTop: $(target).offset().top - 80,
  //     },
  //     1000
  //   );
  // });

  $('a[href*="#"], a[href^="/#"]').on("click", function (e) {
    if (
      (this.href.indexOf(window.location.pathname) > -1) &
      (window.location.pathname.length > 2)
    ) {
      e.preventDefault();

      var target = this.hash;
      target = target.replace("#", "");

      window.ignoreLoadScroll = true;

      var $target = $("#" + target + "-scroll");

      // Close the menu if it's open
      console.log("click");
      $(".menu-opening .header__icon--menu").click();

      if ($target.offset()) {
        $("html, body").animate(
          {
            scrollTop:
              $target.offset().top - $("#shopify-section-header").height() - 32,
          },
          700,
          "swing",
          function () {
            // window.location.hash = "#" + target;
            window.history.replaceState(
              "",
              document.title,
              window.location.href.replace(location.hash, "") + "#" + target
            );
          }
        );
      }
    }
  });
});

$(window).load(function (e) {
  if ($("body").hasClass("product")) {
    setTimeout(() => {
      $(document).scrollTop(0);
    }, 00);
  } else {
    setTimeout(() => {
      $(document).scrollTop(50);
    }, 00);
    setTimeout(() => {
      $(document).scrollTop(0);
    }, 15);
  }

  // scrollTo if #_ found
  var target = window.location.hash,
    target = target.replace("#", "");
  var $target = $("#" + target + "-scroll");
  if (target && !window.ignoreLoadScroll && $target.offset()) {
    setTimeout(() => {
      $("html, body").animate(
        {
          scrollTop:
            $target.offset().top - $("#shopify-section-header").height() - 32,
        },
        700,
        "swing",
        function () {
          window.location.hash = "#" + target;
          ignoreLoadScroll = true;
        }
      );
    }, 300);
  }

  if (window.innerWidth > 1024 && $("body").hasClass("product")) {
    $(window).scroll(function () {
      var scrolled = $(window).scrollTop();
      $(".product__media-item:nth-child(even) ").each(function (
        index,
        element
      ) {
        if (window.innerWidth > 1024) {
          var initY = $(this).offset().top;
          var height = $(this).parent().height();
          var endY = initY + $(this).parent().height();

          // console.log("what is the previous one", $(this).prev().prev().find('.product__modal-opener--image').client);

          // Check if the element is in the viewport.
          // var visible = isInViewport(this);
          // if (visible) {
          var diff = scrolled - initY;
          var ratio = Math.round(diff / height);

          // if ($(this).prev().prev().find('.product__modal-opener--image')) {

          // } else {
          $(this).css(
            "transform",
            "translateY(" + parseInt(-(scrolled * 0.4) + 40) + "px)"
          );
        } else {
          $(this).css("transform", "translateY(0px)");
        }
      });
    });
  }

  if (document.querySelector("body").classList.contains("index")) {
    $("#shopify-section-footer").appendTo("#MainContent");
  }
});

const appHeight = () => {
  const doc = document.documentElement;
  document.documentElement.style.setProperty(
    "--app-height",
    `${window.innerHeight}px`
  );

  doc.style.setProperty("—-app-height", `${window.innerHeight}px`);
};
window.addEventListener("resize", appHeight);

appHeight();
